import { Scenario, ScenarioType, Steps } from '../state/interfaces'

import {
  emailAddressAlert,
  confirmAlert,
  thanksAlertCompetition,
  addressLocationAlert,
  selectCurrentProviderInternetAlert,
  internetSpeedCompetition,
  currentMonthlyPayment,
  sliderSavingsPercent,
} from './alert-steps'

export const competitionInternetAlertScenarioA: Scenario = {
  id: 'competition-internet-alert-a',
  initialStep: Steps.ADDRESS_LOCATION,
  type: ScenarioType.COMPETITION_INTERNET_ALERT,
  version: '1',
  milestones: [
    addressLocationAlert.id,
    internetSpeedCompetition.id,
    // monthlyUsage.id,
    // optionsAlert.id,
    selectCurrentProviderInternetAlert.id,
    currentMonthlyPayment.id,
    sliderSavingsPercent.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertCompetition.id,
  ],
  steps: [
    addressLocationAlert,
    internetSpeedCompetition,
    // monthlyUsage,
    // optionsAlert,
    selectCurrentProviderInternetAlert,
    currentMonthlyPayment,
    sliderSavingsPercent,
    emailAddressAlert,
    confirmAlert,
    thanksAlertCompetition,
  ],
}
